import { Box, BoxProps } from "@chakra-ui/react";

export function GreenArrow({
  color = "currentColor",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box color={color} {...props}>
      <svg
        width="14"
        height="13"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.50016 5.92441V8.46158C7.50016 8.60325 7.45222 8.72203 7.35633 8.81791C7.26044 8.91369 7.14166 8.96158 7 8.96158C6.85822 8.96158 6.73839 8.91308 6.6405 8.81608C6.54272 8.71897 6.49383 8.59869 6.49383 8.45525V5.92441L5.60533 6.81291C5.513 6.90525 5.39694 6.9503 5.25716 6.94808C5.1175 6.94597 5.0015 6.89875 4.90916 6.80641C4.81683 6.71419 4.77066 6.59786 4.77066 6.45741C4.77066 6.31697 4.81683 6.2013 4.90916 6.11041L6.572 4.45391C6.69244 4.33347 6.83305 4.27325 6.99383 4.27325C7.1545 4.27325 7.29505 4.33347 7.4155 4.45391L9.07833 6.11675C9.17066 6.20908 9.21683 6.32403 9.21683 6.46158C9.21683 6.59925 9.17066 6.71419 9.07833 6.80641C8.986 6.89875 8.86961 6.94491 8.72916 6.94491C8.58872 6.94491 8.47305 6.89875 8.38216 6.80641L7.50016 5.92441ZM6.999 12.8334C7.875 12.8334 8.69839 12.6672 9.46916 12.3347C10.2399 12.0023 10.9104 11.5511 11.4805 10.9812C12.0506 10.4114 12.502 9.74119 12.8347 8.97075C13.1672 8.2003 13.3335 7.37714 13.3335 6.50125C13.3335 5.62525 13.1673 4.80186 12.8348 4.03108C12.5024 3.2603 12.0512 2.58986 11.4813 2.01975C10.9114 1.44964 10.2413 0.998248 9.47083 0.665581C8.70039 0.333026 7.87722 0.166748 7.00133 0.166748C6.12533 0.166748 5.30194 0.33297 4.53116 0.665414C3.76039 0.997859 3.08994 1.44903 2.51983 2.01891C1.94972 2.5888 1.49833 3.25897 1.16566 4.02941C0.833108 4.79986 0.66683 5.62303 0.66683 6.49891C0.66683 7.37491 0.833052 8.1983 1.1655 8.96908C1.49794 9.73986 1.94911 10.4103 2.519 10.9804C3.08889 11.5505 3.75905 12.0019 4.5295 12.3346C5.29994 12.6671 6.12311 12.8334 6.999 12.8334Z"
          fill="#3AB65A"
        />
      </svg>
    </Box>
  );
}
